export default {"src":"/_next/static/media/joomla.2d5f2814.svg","height":106,"width":105,"blurWidth":0,"blurHeight":0};